import { Component, ViewEncapsulation,Input, Output, EventEmitter, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from './../../../app/services/auth.service';
import { ActivityViewDataService } from './../../services/activity-view-data.service';
import { ActivityViewHelperService } from './../../services/activity-view-helper.service';
import { LoaderService } from '../../../app/services/loader.service';
import { Subscription } from 'rxjs';
import { GigyaSessionService } from '../../../app/services/gigya-session.service';
import { AppHelperService } from '../../../app/services/app-helper.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'activity-renderer',
    templateUrl: './activity-renderer.template.html',
    styleUrls: ['./activity-renderer.style.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class ActivityRenderer implements OnInit, OnDestroy {
  selectedItemSubscription: Subscription;
  closeActivitySubscription: Subscription;
  isThisAssignmentActivity: boolean = false;
  currentActivityId: string;
  selectedLesson: any;
  selectedActivity: any;
  unitIndex: number;
  lessonIndex: number;
  activityIndex: number;
  public imagesBasePath: string = IMAGES_BASEPATH;
  @Input() previewMode: string;
  @Input() isTeacher: boolean;
  @Input() tocArray : any[];
  @Input() selectedItem : any;
  /* Boolean to show/hide the activity container */
  @Input() showResultScreen: boolean;
  @Input() isGameActivity: boolean;

  @ViewChild('closeActivityBtn') closeActivityBtn : ElementRef;

  constructor(private gigyaSessionService: GigyaSessionService,
    private router: Router,
    private authService: AuthService,
    private activityViewDataService: ActivityViewDataService,
    private loaderService: LoaderService,
    public activityViewHelperService: ActivityViewHelperService,
    private appHelperService : AppHelperService,
    private readonly route: ActivatedRoute,
    private readonly titleService:Title,
    private translate: TranslateService ) {}

  ngOnInit() {
    this.isThisAssignmentActivity = !!this.route.snapshot.params.assignmentId;
    this.selectedItemSubscription = this.activityViewHelperService.selectedItemId.subscribe( (selectedItemObject: any) => {
      this.currentActivityId = selectedItemObject.itemid;
      this.unitIndex = this.tocArray.findIndex( res => res['item-code']===selectedItemObject.selectedItem.unitId)
      if(this.unitIndex != -1) {
        const selectedUnit = this.tocArray[this.unitIndex]
        if(selectedUnit && selectedUnit.items) {
          this.lessonIndex = selectedUnit.items.findIndex(res => res['item-code']===selectedItemObject.selectedItem.lessonId);
          if(this.lessonIndex !== -1) {
            this.selectedLesson = selectedUnit.items[this.lessonIndex];
            if(this.selectedLesson && this.selectedLesson.items) {
              this.activityIndex = this.selectedLesson.items.findIndex(res=>res['item-code']===selectedItemObject.selectedItem.activityId);
              if(this.activityIndex !== -1) {
                this.selectedActivity = this.selectedLesson.items[this.activityIndex];
                this.titleService.setTitle(this.selectedActivity?.name + this.translate.instant("HTML_META.MAIN.CUSTOM_TITLE"));
              }
            }
          }
        }
      }
    });
    this.closeActivitySubscription = this.activityViewHelperService.closeActivitySubject.subscribe( () => {
      this.closeActivity();
    });
  }

  startLoader() {
    this.loaderService.showOverlayLoader();
  }
  navigateBack() {
    let userData = this.authService.getUserData();
    //this.appHelperService.showLoaderAndNavigateToDashboard(userData);
    this.appHelperService.navigateToDashboardApp([]);
  }

  closeActivity(goToDashboard = false) {
    this.loaderService.showOverlayLoader();
    if (goToDashboard) {
      // When CUP Logo is clicked
      this.navigateUserToDashboard();
    } else if (this.isThisAssignmentActivity) {
      // When attempting an assignment, navigate to Assignments' Page
      const routeParams = this.route.snapshot.params;
      const options = { hashParams: { aid: routeParams.assignmentId } };
      this.appHelperService.navigateToClassApp(['learner', routeParams.spaceId, 'class', routeParams.classId, 'assignments'], options);
    } else {
      // Else go to product Toc page
      this.navigateUserToHome();
    }
  }

  private navigateUserToHome() {
    let requiredQueryParams = this.appHelperService.getRequiredQueryParams(this.route.snapshot.queryParams, ['lf', 'cid', 'bcode', 'rcode', 'ltik', 'b']);
    this.router.navigate(['../'], { relativeTo: this.route, queryParams: requiredQueryParams });
  }

  private navigateUserToDashboard() {
    const { queryParams, params } = this.route.snapshot;
    if(queryParams.lf == 'ltd') {
      this.appHelperService.navigateToOnboardingApp(['lti-teacher-dashboard', params.spaceId, 'class', queryParams.cid, 'ltik', queryParams.ltik]);
    } else if(queryParams.lf == 'ltc') {
      this.appHelperService.navigateToOnboardingApp(['lti-component-selection', params.spaceId, 'class', queryParams.cid, 'bundle', queryParams.bcode, 'resource', queryParams.rcode, 'ltik', queryParams.ltik]);
    } else {
      const userAgent = window.navigator && window.navigator.userAgent && window.navigator.userAgent.toLowerCase();
      const forceExit = ((userAgent.includes('firefox') || userAgent.includes('safari') || userAgent.includes('ipad')) && !userAgent.includes('chrome'));
      this.appHelperService.navigateToDashboardApp([], { forceExit });
    }
  }

  ngOnDestroy() {
      if (this.selectedItemSubscription) {
        this.selectedItemSubscription.unsubscribe();
      }
      if (this.closeActivitySubscription) {
        this.closeActivitySubscription.unsubscribe();
      }
      this.titleService.setTitle(this.translate.instant("HTML_META.MAIN.TITLE"));
  }
}
